import { privateInstance } from "../configs";
import { mappers } from "@/mappers";
import moment from "moment";

export const tillApi = {
  async getTills() {
    const res = await privateInstance.get("caisse/api/till/");
    return res.data.map(x => mappers.mapTill(x));
  },
  async postTill(data) {
    const res = await privateInstance.post("caisse/api/till/", data);
    return mappers.mapTill(res.data);
  },
  async retrieveTill(id) {
    const res = await privateInstance.get(`caisse/api/till/${id}/`);
    return mappers.mapTill(res.data);
  },
  async getDeposits() {
    const res = await privateInstance.get("caisse/api/deposit/");
    return res.data;
  },
  async postDeposit(data) {
    const res = await privateInstance.post("caisse/api/deposit/", data);
    return res.data;
  },
  async getTips(params) {
    let req = "caisse/api/tips/";
    if (params) {
      req += "?";
      let reqArray = [];
      if (params.start) {
        reqArray.push(`start=${moment(params.start).format("YYYY-MM-DD")}`);
      }
      if (params.end) {
        reqArray.push(`end=${moment(params.end).format("YYYY-MM-DD")}`);
      }
      req += reqArray.join("&");
    }
    const res = await privateInstance.get(req);
    return res.data;
  },
  async postTips(data) {
    const res = await privateInstance.post("caisse/api/tips/", data);
    return res.data;
  },
  async postPayments(data) {
    const res = await privateInstance.post("caisse/api/payments/", data);
    return res.data;
  },
  async postCaisse(data) {
    const res = await privateInstance.post("caisse/api/caisse/", data);
    return res.data;
  },
  async postDirectPurchase(data) {
    const res = await privateInstance.post("caisse/api/debourse/", data);
    return res.data;
  },
  async getDefaultFondCaisse() {
    const res = await privateInstance.get("caisse/api/fcaisse/default/");
    return res.data;
  },
  async retrieveFondCaisse(id) {
    const res = await privateInstance.get(`caisse/api/fcaisse/${id}/`);
    return res.data;
  },
  async patchFondCaisse(id, data) {
    const res = await privateInstance.patch(`caisse/api/fcaisse/${id}/`, data);
    return res.data;
  },
  async postFondCaisse(data) {
    const res = await privateInstance.post("caisse/api/fcaisse/default/", data);
    return res.data;
  }
};
